<template>
  <div class="findlayzbflfw">
    <sec-title class="text_center" Text="周边法律服务" />
    <div class="tagtitle">
      <span>法律援助</span>
      <span>司法公正</span>
      <span>司法鉴定</span>
      <span>人民调解</span>
      <span>地方法院</span>
    </div>
    <div class="tagcont between">
      <div class="titem" v-for="item in 4" :key="item">
        <div class="top flex-col">
          <div class="toptitle">#法律援助</div>
          <div class="tagadress">安徽省肥西县公正处</div>
        </div>
        <div class="bottom">
          <div class="flex_start ellipsis">
            <!-- <img src="../../../assets/findlawyers/dianhua.png" /> -->
            <svg-icon icon-class="dianhua" class="svgimg"/>
             188-5578-011
          </div>
          <div class="botmadress ellipsis">
            机构地址：安徽省肥西县XXXXXXXXXXX
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import secTitle from "views/home/components/secTitle";
export default {
  components: {
    secTitle,
  },
};
</script>

<style lang="scss" scope>
.findlayzbflfw {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .tagtitle {
    margin-top: 20px;
    padding: 10px 0;
    border-bottom: 1px solid #e5e5e5;
    span {
      padding-right: 20px;
      color: #333333;
      border-right: 1px solid #333333;
      margin-right: 20px;
      font-size: 20px;
      &:last-child {
        border-right: none;
      }
    }
  }
  .tagcont {
    .titem {
      width: 284px;
      border: 1px solid #f8f8f8;

      &:hover {
        border-top:1px solid  #0465EA;
        box-shadow: 0px 6px 38px 0px #efeff4;
      }
      .top {
        width: 100%;
        height: 156px;
        padding: 0 23px;
		justify-content: flex-start;
		align-items: flex-start;
        background: url("../../../assets/findlawyers/aroundlaw_bg.png");
        .toptitle {
          font-size: 16px;
          line-height: 16px;
          color: #999999;
          padding-top: 30px;
        }
        .tagadress {
          margin-top: 20px;
          font-size: 20px;
          line-height: 20px;
          color: #333333;
          position: relative;
          &::after {
            content: "";
            position: absolute;
            bottom: -20px;
            left: 0;
            width: 20px;
            height: 3px;
            background: #aaa;
          }
        }
      }
      .bottom {
        padding: 28px 23px;
        font-size: 18px;
        .svgimg {
          color: #555555;
          font-size: 14px;
          margin-right: 8px;
        }
        .botmadress {
          margin-top: 16px;
          font-size: 14px;
          color: #999999;
        }
      }
    }
  }
}
</style>